import Image from "components/Elements/Image/Image";
import { LinkToNewTab } from "components/Elements/Link/Link";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./pickerPromoModals.module.scss";
import Button from "components/Elements/Button/Button";
import { useModal } from "contexts/modalContext/modalContext";
import { setLocalStorage } from "utils/globalLocalStorage";
import Icon from "components/Elements/Icon/Icon";

const PickerPromoHideIconModal = () => {
  const { getTextByKey } = useContent();
  const { closeModal } = useModal();

  const onCancel = () => {
    closeModal();
  };

  const onHide = () => {
    setLocalStorage("hidePickerPromo", "true");
    closeModal();
  };

  return (
    <div className={styles.hideIconModal}>
      <div className={styles.imageContainer}>
        <Icon name="show-text" />
      </div>
      <h3>{getTextByKey("hide-picker-button-title")}</h3>
      <p>
        {getTextByKey("hide-picker-button-description")} {/* @ts-ignore */}
        <LinkToNewTab page="inbox">{getTextByKey("inbox")}</LinkToNewTab>
      </p>
      <div className={styles.buttons}>
        <Button onClick={onCancel} buttonClass={styles.cancelButton}>
          {getTextByKey("cancel")}
        </Button>
        <Button onClick={onHide} buttonClass={styles.hideButton}>
          {getTextByKey("hide-icon")}
        </Button>
      </div>
    </div>
  );
};

export default PickerPromoHideIconModal;
